import { ReportRunView } from '../../Views/Home/ReportsBuilderView/ReportRunView/ReportRunView';
import { ReportRunViewTemp } from '../../Views/Home/ReportsBuilderView/ReportRunView/ReportRunViewTemp';
import { ReportPdfView } from '../../Views/Share/ReportPdfView/ReportPdfView';
import UnitCardView from '../../Views/Share/UnitCardView/UnitCardView';
import { ClientSegmentationRunView } from '../../Views/Home/MarketingClientsSegmentation/ClientSegmentationManagementView/ClientSegmentationRunView';
import { ReleaseNoteView } from '../../Views/Share/ReleaseNoteView';
import { MySupportTicketsView } from '../../Views/Share/MySupportTicketsView';
import AgentForm from '../../Views/Home/ContactsView/ContactProfileManagementView/Sections/KycViewComponent/Tabs/KycForms/Forms/AgentForm/AgentForm'

export const ShareRoutes = [
    {
        path: '/UnitCard',
        name: 'Unit Card',
        component: UnitCardView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
    }, {
        path: '/ReportPdfView',
        name: 'ReportPdfView',
        component: ReportPdfView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
    },
    {
        path: '/ReportRunView',
        name: 'ReportRunView',
        component: ReportRunView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
    },
    {
        path: '/ReportRunTempView',
        name: 'ReportRunView',
        component: ReportRunViewTemp,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
    },
    {
        path: '/ClientSegmentationRunView',
        name: 'Client Segmentation Run View',
        component: ClientSegmentationRunView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
    },
    {
        path: '/release-note',
        name: 'ReleaseNote',
        component: ReleaseNoteView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
      },
    {
        path: '/my-support-tickets',
        name: 'MySupportTickets',
        component: MySupportTicketsView,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
      },
      {
        path: '/agent-approval-kyc',
        name: 'AgentApprovalKyc',
        component: AgentForm,
        layout: '/share',
        default: true,
        isExact: true,
        authorize: false,
        roles: [],
        showInMenu: false,
        isRoute: true,
      },
];
